import { render, staticRenderFns } from "./gradual-injection-select.vue?vue&type=template&id=38167747"
import script from "./gradual-injection-select.vue?vue&type=script&lang=js"
export * from "./gradual-injection-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38167747')) {
      api.createRecord('38167747', component.options)
    } else {
      api.reload('38167747', component.options)
    }
    module.hot.accept("./gradual-injection-select.vue?vue&type=template&id=38167747", function () {
      api.rerender('38167747', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/installation/components/gradual-injection-select.vue"
export default component.exports